// @flow

import * as React from 'react';
import {Bar} from 'react-chartjs-2';

import type {CalculationResultDetails} from "../common/RequestTypes";
import ColorManager from "../common/ColorManager";
import type {Color} from "../common/ColorManager";
import ReactAI from 'react-appinsights';

type Props = {
    calculationResultDetails: CalculationResultDetails
};


class TotalClimateEffectChart extends React.Component<Props> {
    
    colorManager: ColorManager;
    
    constructor() {
        super();
        this.colorManager = new ColorManager();
    }
    
    render() {

        const options = {
            scales: {
                xAxes: [{
                    stacked: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'NoDig - Traditionell grävning'
                    }
                }],
                yAxes: [{
                    stacked: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'ton CO₂e'
                    },
                    ticks: {
                        beginAtZero: true
                    }
                }]
            },
            legend: {
                position: 'top'
                // display: false
            },
            tooltips: {
                callbacks: {
                    label: (tooltipItem, data) => {
                        let techName = data.datasets[tooltipItem.datasetIndex].label;
                        let formattedValue = parseFloat(tooltipItem.yLabel.toFixed(1));
                        return `${techName}: ${formattedValue} ton CO₂e`;
                    }
                }
            }
        };

        let datasets = [];

        if(this.props.calculationResultDetails.insertionFlexibleLining.totalDerived > 0) {
            datasets = [...datasets, this.createDataSet(this.props.calculationResultDetails.insertionFlexibleLining.totalDerived,
                this.colorManager.colorInsertionFlexibleLining, "Infodring flexibla foder", true)];
        }
        
        if(this.props.calculationResultDetails.tubeCracking.totalDerived > 0) {
            datasets = [...datasets, this.createDataSet(this.props.calculationResultDetails.tubeCracking.totalDerived,
                this.colorManager.colorTubeCracking, "Rörspräckning", true)];
        }

        if(this.props.calculationResultDetails.directedDrilling.totalDerived > 0) {
            datasets = [...datasets, this.createDataSet(this.props.calculationResultDetails.directedDrilling.totalDerived,
                this.colorManager.colorDirectedDrilling, "Styrd borrning", true)];
        }

        if(this.props.calculationResultDetails.slipLining.totalDerived > 0) {
            datasets = [...datasets, this.createDataSet(this.props.calculationResultDetails.slipLining.totalDerived,
                this.colorManager.colorSliplining, "Sliplining", true)];
        }

        if(this.props.calculationResultDetails.puLiner.totalDerived > 0) {
            datasets = [...datasets, this.createDataSet(this.props.calculationResultDetails.puLiner.totalDerived,
                this.colorManager.colorPuLiner, "PU liner", true)];
        }

        datasets = [...datasets, this.createDataSet(this.props.calculationResultDetails.traditionalDigging.totalDerived,
            this.colorManager.colorTraditionalDigging, "Traditionell grävning", false)];
        
        let data = {
            datasets,
            labels:['']
        };

        return (
            <Bar
                data={data}
                options={options}
            />
        );
    }

    createDataSet(total: number, color: Color, name: string, isNoDig: boolean) {
        let label = (isNoDig ? "NoDig - " : "") + name;
        let dataSet = {
            label,
            data: [total / 1000],
            stack: isNoDig ? 'NoDig' : "Traditionell grävning",
        };
        let colorProperties = this.colorManager.getChartColorProperties(color);
        return {...dataSet, ...colorProperties};
    }
    
}

export default ReactAI.withTracking(TotalClimateEffectChart); 





// WEBPACK FOOTER //
// ./src/components/TotalClimateEffectChart.js